// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { motion } from "framer-motion";
// import SummaryApi from "../common";
// import displayINRCurrency from "../helpers/displayCurrency";
// import addToCart from "../helpers/addToCart";
// import { useDispatch } from "react-redux";
// import ReviewSection from "../components/ReviewSection";

// const ProductDetails = () => {

//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [data, setData] = useState({});
//   const [activeImage, setActiveImage] = useState("");
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [activeTab, setActiveTab] = useState(0);

//   /* FETCH */
//   const fetchProduct = async () => {
//     const res = await fetch(SummaryApi.productDetails.url, {
//       method: "POST",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({ productId: id }),
//     });

//     const result = await res.json();

//     setData(result.data);
//     setActiveImage(result.data?.productImage?.[0]);

//     if (result.data?.variants?.length) {
//       setSelectedVariant(result.data.variants[0]);
//     }
//   };

//   useEffect(() => {
//     fetchProduct();
//   }, [id]);

//   /* VARIANT FIX */
//   const uniqueRAM = [...new Set(data?.variants?.map(v => v.ram))];
//   const uniqueStorage = [...new Set(data?.variants?.map(v => v.storage))];

//   /* CART */
//   const handleAddToCart = () => {
//     addToCart(data._id, selectedVariant, dispatch);
//   };

//   const handleBuyNow = () => {
//     addToCart(data._id, selectedVariant, dispatch);
//     window.location.href = "/checkout";
//   };

//   const discount = data.price && selectedVariant?.price
//     ? Math.round(((data.price - selectedVariant.price) / data.price) * 100)
//     : 0;

//   const specSections = Object.entries(data?.specifications || {});

//   return (
//     <div className="bg-[#f6f7fb] min-h-screen p-4">

//       <div className="container mx-auto">

//         {/* 🔥 TOP */}
//         <div className="grid lg:grid-cols-2 gap-10 bg-white p-6 rounded-2xl shadow">

//           {/* 🖼 IMAGE */}
//           <div>
//             <motion.img
//               key={activeImage}
//               src={activeImage}
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               className="w-full h-[380px] object-contain bg-gray-50 p-4 rounded-xl"
//             />

//             <div className="flex gap-3 mt-4">
//               {data?.productImage?.map((img) => (
//                 <img
//                   key={img}
//                   src={img}
//                   onClick={() => setActiveImage(img)}
//                   className={`w-20 h-20 border rounded cursor-pointer
//                   ${activeImage === img ? "border-blue-600" : ""}`}
//                 />
//               ))}
//             </div>
//           </div>

//           {/* 🧾 DETAILS */}
//           <div>

//             <h1 className="text-2xl font-semibold">
//               {data.productName}
//             </h1>

//             <div className="flex gap-3 items-center mt-3">
//               <h2 className="text-3xl font-bold text-blue-600">
//                 {displayINRCurrency(selectedVariant?.price)}
//               </h2>

//               <span className="line-through text-gray-400">
//                 {displayINRCurrency(data.price)}
//               </span>

//               {discount > 0 && (
//                 <span className="bg-green-100 text-green-600 px-2 py-1 rounded">
//                   {discount}% OFF
//                 </span>
//               )}
//             </div>

//             {/* RAM */}
//             <div className="mt-4">
//               <p className="font-medium">RAM</p>
//               <div className="flex gap-2 mt-2">
//                 {uniqueRAM.map((ram, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.ram === ram)
//                       )
//                     }
//                     className={`px-3 py-1 border rounded
//                     ${selectedVariant?.ram === ram ? "bg-blue-600 text-white" : ""}`}
//                   >
//                     {ram}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* STORAGE */}
//             <div className="mt-4">
//               <p className="font-medium">Storage</p>
//               <div className="flex gap-2 mt-2">
//                 {uniqueStorage.map((storage, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.storage === storage)
//                       )
//                     }
//                     className={`px-3 py-1 border rounded
//                     ${selectedVariant?.storage === storage ? "bg-blue-600 text-white" : ""}`}
//                   >
//                     {storage}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* BUTTONS */}
//             <div className="flex gap-4 mt-6">

//               <button
//                 onClick={handleAddToCart}
//                 className="flex-1 border py-2 rounded"
//               >
//                 Add to Cart
//               </button>

//               <button
//                 onClick={handleBuyNow}
//                 className="flex-1 bg-blue-600 text-white py-2 rounded"
//               >
//                 Buy Now
//               </button>

//             </div>

//           </div>

//         </div>

//         {/* 🔥 SPECIFICATIONS WITH TABS */}

// <div className="bg-white mt-12 p-6 md:p-8 rounded-3xl shadow-lg">

//   {/* HEADER */}
//   <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
//     <h2 className="text-2xl md:text-3xl font-bold">
//       Technical Specifications
//     </h2>

//     <p className="text-sm text-gray-500 mt-2 md:mt-0">
//       Detailed product information
//     </p>
//   </div>

//   {/* 🔥 TABS (PREMIUM STYLE) */}
//   <div className="flex gap-3 overflow-x-auto pb-3 mb-8 no-scrollbar">

//     {specSections.map(([section], index) => (
//       <motion.button
//         key={index}
//         whileTap={{ scale: 0.95 }}
//         onClick={() => setActiveTab(index)}
//         className={`px-5 py-2 rounded-full whitespace-nowrap text-sm font-medium transition-all
//         ${
//           activeTab === index
//             ? "bg-gradient-to-r from-red-500 to-orange-500 text-white shadow-md"
//             : "bg-gray-100 hover:bg-gray-200 text-gray-700"
//         }`}
//       >
//         {section}
//       </motion.button>
//     ))}

//   </div>

//   {/* 🔥 CONTENT */}
//   {specSections.length > 0 && (
//     <motion.div
//       key={activeTab}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.3 }}
//       className="grid sm:grid-cols-2 md:grid-cols-3 gap-6"
//     >

//       {Object.entries(specSections[activeTab][1]).map(([key, val]) => (
//         <div
//           key={key}
//           className="bg-gray-50 hover:bg-white border rounded-xl p-4 transition shadow-sm hover:shadow-md"
//         >

//           <p className="text-gray-500 text-xs uppercase tracking-wide">
//             {key}
//           </p>

//           <p className="font-semibold text-gray-800 mt-1">
//             {val || "-"}
//           </p>

//         </div>
//       ))}

//     </motion.div>
//   )}

// </div>
// <ReviewSection/>
//       </div>

//     </div>
//   );
// };

// export default ProductDetails;

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { motion } from "framer-motion";
// import SummaryApi from "../common";
// import displayINRCurrency from "../helpers/displayCurrency";
// import addToCart from "../helpers/addToCart";
// import { useDispatch } from "react-redux";

// const ProductDetails = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const [data, setData] = useState({});
//   const [activeImage, setActiveImage] = useState("");
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [qty, setQty] = useState(1);

//   const fetchProduct = async () => {
//     const res = await fetch(SummaryApi.productDetails.url, {
//       method: "POST",
//       credentials:"include",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({ productId: id }),
//     });

//     const result = await res.json();
//     setData(result.data);
//     setActiveImage(result.data?.productImage?.[0]);

//     if (result.data?.variants?.length) {
//       setSelectedVariant(result.data.variants[0]);
//     }
//   };

//   useEffect(() => {
//     fetchProduct();
//   }, [id]);

//   const uniqueRAM = [...new Set(data?.variants?.map(v => v.ram))];
//   const uniqueStorage = [...new Set(data?.variants?.map(v => v.storage))];

//   const discount =
//     data.price && selectedVariant?.price
//       ? Math.round(((data.price - selectedVariant.price) / data.price) * 100)
//       : 0;

//   const handleAddToCart = () => {
//     addToCart(data._id, selectedVariant, dispatch, qty);
//   };

//   const handleBuyNow = () => {
//     addToCart(data._id, selectedVariant, dispatch, qty);
//     window.location.href = "/checkout";
//   };

//   return (
//     <div className="bg-[#f4f6fb] min-h-screen p-4">
//       <div className="max-w-7xl mx-auto">

//         <div className="grid lg:grid-cols-2 gap-10 bg-white rounded-3xl p-6 shadow">

//           {/* LEFT IMAGE */}
//           <div className="flex gap-4">

//             {/* thumbnails */}
//             <div className="flex flex-col gap-3">
//               {data?.productImage?.map((img) => (
//                 <img
//                   key={img}
//                   src={img}
//                   onClick={() => setActiveImage(img)}
//                   className={`w-16 h-16 object-cover rounded cursor-pointer border
//                   ${activeImage === img ? "border-red-500" : ""}`}
//                 />
//               ))}
//             </div>

//             {/* main image */}
//             <div className="flex-1">
//               <motion.img
//                 key={activeImage}
//                 src={activeImage}
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 className="w-full h-[400px] object-contain rounded-xl bg-[#f7f8fb]"
//               />
//             </div>
//           </div>

//           {/* RIGHT DETAILS */}
//           <div>

//             <h1 className="text-2xl font-semibold">
//               {data.productName}
//             </h1>

//             {/* PRICE */}
//             <div className="mt-4">
//               <h2 className="text-3xl font-bold text-red-600">
//                 {displayINRCurrency(selectedVariant?.price)}
//               </h2>

//               <div className="flex gap-3 items-center mt-1">
//                 <span className="line-through text-gray-400">
//                   {displayINRCurrency(data.price)}
//                 </span>

//                 <span className="text-red-500 font-medium">
//                   ({discount}% OFF)
//                 </span>
//               </div>

//               <p className="text-sm text-red-500 mt-2">
//                 🔥 Low Stock Only 18 left!
//               </p>
//             </div>

//             {/* OFFER BOX */}
//             <div className="bg-green-50 border border-green-200 p-4 rounded-xl mt-4">
//               <p className="font-semibold text-green-700">
//                 Limited Time Offer
//               </p>
//               <p className="text-sm text-green-600">
//                 Instant ₹500 Off – Use code <b>First500</b>
//               </p>
//             </div>

//             {/* RAM */}
//             <div className="mt-6">
//               <p className="font-medium">RAM</p>
//               <div className="flex gap-3 mt-2">
//                 {uniqueRAM.map((ram, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.ram === ram)
//                       )
//                     }
//                     className={`px-4 py-2 border rounded-lg
//                     ${selectedVariant?.ram === ram
//                         ? "border-red-500 text-red-500"
//                         : "border-gray-300"
//                       }`}
//                   >
//                     {ram}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* STORAGE */}
//             <div className="mt-6">
//               <p className="font-medium">Storage</p>
//               <div className="flex gap-3 mt-2">
//                 {uniqueStorage.map((storage, i) => (
//                   <button
//                     key={i}
//                     onClick={() =>
//                       setSelectedVariant(
//                         data.variants.find(v => v.storage === storage)
//                       )
//                     }
//                     className={`px-4 py-2 border rounded-lg
//                     ${selectedVariant?.storage === storage
//                         ? "border-red-500 text-red-500"
//                         : "border-gray-300"
//                       }`}
//                   >
//                     {storage}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* QUANTITY */}
//             <div className="flex items-center gap-4 mt-6">
//               <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)} className="px-3 py-1 border">-</button>
//               <span>{qty}</span>
//               <button onClick={() => setQty(qty + 1)} className="px-3 py-1 border">+</button>
//             </div>

//             {/* BUTTONS */}
//             <div className="mt-6 flex gap-4">

//               <button
//                 onClick={handleAddToCart}
//                 className="flex-1 py-3 rounded-full text-white font-semibold
//                 bg-gradient-to-r from-red-600 to-red-500 hover:scale-105 transition"
//               >
//                 ADD TO CART
//               </button>

//               <button
//                 onClick={handleBuyNow}
//                 className="flex-1 py-3 rounded-full bg-black text-white font-semibold"
//               >
//                 BUY IT NOW
//               </button>

//             </div>

//           </div>

//         </div>

//       </div>
//     </div>
//   );
// };

// export default ProductDetails;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import displayINRCurrency from "../helpers/displayCurrency";
import addToCart from "../helpers/addToCart";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const ProductDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [qty, setQty] = useState(1);
  const [recommended, setRecommended] = useState([]);

  // 🔥 FETCH PRODUCT
  const fetchProduct = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/product-details", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId: id }),
    });

    const result = await res.json();
    const product = result.data;

    setData(product);

    // ✅ FIX: default variant
    if (product?.variants?.length > 0) {
      setSelectedVariant(product.variants[0]);
    }
  };

  // 🔥 FETCH RECOMMENDED
  const fetchRecommended = async () => {
    const res = await fetch("https://lappyshop.onrender.com/api/get-product");
    const result = await res.json();

    if (result.success) {
      setRecommended(result.data.slice(0, 10));
    }
  };

  useEffect(() => {
    fetchProduct();
    fetchRecommended();
  }, [id]);

  // 🔥 AUTO IMAGE SLIDER
  useEffect(() => {
    if (!data?.productImage?.length) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % data.productImage.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [data]);

  const activeImage = data?.productImage?.[activeIndex];

  // 🔥 VARIANT FIX
  const handleVariantChange = (type, value) => {
    if (!data?.variants) return;

    let newVariant;

    if (type === "ram") {
      newVariant = data.variants.find(
        (v) =>
          v.ram === value &&
          v.storage === selectedVariant?.storage
      );
    } else {
      newVariant = data.variants.find(
        (v) =>
          v.storage === value &&
          v.ram === selectedVariant?.ram
      );
    }

    if (newVariant) setSelectedVariant(newVariant);
  };

  // 🔥 PRICE FIX (NO NaN)
  const price = selectedVariant?.price || 0;
  const actual = data?.price || price;

  const discount =
    actual > price ? Math.round(((actual - price) / actual) * 100) : 0;

  return (
    <div className="bg-[#f6f7fb] min-h-screen py-6 px-3">

      <div className="max-w-7xl mx-auto">

        {/* 🔥 TOP SECTION */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 bg-white rounded-2xl p-5 shadow">

          {/* LEFT IMAGE */}
          <div>

            {/* MAIN IMAGE */}
            <div className="relative group overflow-hidden rounded-xl bg-gray-100">
              <motion.img
                key={activeImage}
                src={activeImage}
                alt="product"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="w-full h-[300px] md:h-[420px] object-contain transition duration-500 group-hover:scale-125"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition"></div>
            </div>

            {/* THUMBNAILS */}
            <div className="flex gap-2 mt-3 overflow-x-auto">
              {data?.productImage?.slice(0, 6).map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt=""
                  onClick={() => setActiveIndex(i)}
                  className={`w-16 h-16 object-cover rounded cursor-pointer border 
                  ${activeIndex === i ? "border-red-500" : ""}`}
                />
              ))}
            </div>

          </div>

          {/* RIGHT */}
          <div>

            <h1 className="text-xl md:text-2xl font-bold">
              {data.productName}
            </h1>

            {/* PRICE */}
            <div className="mt-3">
              <p className="text-3xl font-bold text-red-600">
                {displayINRCurrency(price)}
              </p>

              <div className="flex gap-3 text-sm">
                <span className="line-through text-gray-400">
                  {displayINRCurrency(actual)}
                </span>
                <span className="text-green-600 font-semibold">
                  {discount}% OFF
                </span>
              </div>
            </div>

            {/* VARIANTS */}
            <div className="mt-5">

              <p className="font-medium">RAM</p>
              <div className="flex gap-2 mt-2 flex-wrap">
                {[...new Set(data?.variants?.map(v => v.ram))].map((ram) => (
                  <button
                    key={ram}
                    onClick={() => handleVariantChange("ram", ram)}
                    className={`px-4 py-1 rounded-lg border 
                    ${selectedVariant?.ram === ram ? "bg-black text-white" : ""}`}
                  >
                    {ram}
                  </button>
                ))}
              </div>

              <p className="font-medium mt-4">Storage</p>
              <div className="flex gap-2 mt-2 flex-wrap">
                {[...new Set(data?.variants?.map(v => v.storage))].map((s) => (
                  <button
                    key={s}
                    onClick={() => handleVariantChange("storage", s)}
                    className={`px-4 py-1 rounded-lg border 
                    ${selectedVariant?.storage === s ? "bg-black text-white" : ""}`}
                  >
                    {s}
                  </button>
                ))}
              </div>

            </div>

            {/* QTY */}
            <div className="flex items-center gap-3 mt-5">
              <button onClick={() => setQty(qty > 1 ? qty - 1 : 1)}>-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>

            {/* BUTTONS */}
            <div className="flex gap-3 mt-6 flex-col sm:flex-row">
              <button
                onClick={() => addToCart(data._id, selectedVariant, dispatch, qty)}
                className="flex-1 bg-red-600 text-white py-3 rounded-xl hover:bg-red-700 hover:scale-105 transition"
              >
                Add to Cart
              </button>

              <button
                onClick={() => {
                  addToCart(data._id, selectedVariant, dispatch, qty);
                  window.location.href = "/checkout";
                }}
                className="flex-1 bg-black text-white py-3 rounded-xl"
              >
                Buy Now
              </button>
            </div>

          </div>

        </div>

        {/* 🔥 DESCRIPTION */}
        <div className="bg-white mt-6 p-5 rounded-xl shadow">
          <h2 className="text-lg font-semibold">Description</h2>
          <p className="text-gray-600 mt-2">
            {data.description || "High quality refurbished laptop with warranty."}
          </p>
        </div>

        {/* 🔥 SPECIFICATIONS */}
        <div className="bg-white mt-6 p-5 rounded-xl shadow">

          <h2 className="text-lg font-semibold mb-4">
            Technical Specifications
          </h2>

          <div className="grid md:grid-cols-3 gap-4 text-sm">

            <div className="border p-4 rounded-xl">
              <h3 className="font-semibold mb-2">Performance</h3>
              <p>Processor: {data.processor || "Intel i5"}</p>
              <p>RAM: {selectedVariant?.ram}</p>
              <p>Storage: {selectedVariant?.storage}</p>
            </div>

            <div className="border p-4 rounded-xl">
              <h3 className="font-semibold mb-2">Connectivity</h3>
              <p>WiFi: Yes</p>
              <p>Bluetooth: Yes</p>
              <p>USB Ports: 3</p>
            </div>

            <div className="border p-4 rounded-xl">
              <h3 className="font-semibold mb-2">Display</h3>
              <p>Size: 14 inch</p>
              <p>Resolution: HD</p>
            </div>

          </div>

        </div>

        {/* 🔥 RECOMMENDED */}
        <div className="mt-10">

          <h2 className="text-xl font-bold mb-4">
            Recommended Products
          </h2>

          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2500 }}
            spaceBetween={15}
            breakpoints={{
              0: { slidesPerView: 1.5 },
              640: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
            }}
          >

            {recommended.map((item) => (
              <SwiperSlide key={item._id}>

                <div
                  onClick={() => window.location.href = `/product/${item._id}`}
                  className="bg-white rounded-xl p-3 shadow hover:shadow-lg transition cursor-pointer"
                >

                  <img
                    src={item.productImage?.[0]}
                    alt=""
                    className="h-32 mx-auto object-contain mb-3"
                  />

                  <p className="text-sm font-medium line-clamp-2">
                    {item.productName}
                  </p>

                  <p className="text-red-600 font-semibold mt-1">
                    ₹{item?.variants?.[0]?.price}
                  </p>

                </div>

              </SwiperSlide>
            ))}

          </Swiper>

        </div>

      </div>

    </div>
  );
};

export default ProductDetails;